<div class="toast d-flex align-items-center justify-content-between text-white border-0" [class]="'bg-' + alertType" role="alert" aria-live="assertive" aria-atomic="true" #toast>
  <div class="toast-body">{{ errorText }}</div>
  <button type="button" class="btn-close btn-close-white ml-auto mr-2 p-3" data-bs-dismiss="toast" aria-label="Close"></button>
</div>
